// extracted by mini-css-extract-plugin
module.exports = {"service-box":"CardLayanan_service-box__2avjj","visible":"CardLayanan_visible__3Svrp"};